import type { QuizQuestionPrompt } from 'bundles/compound-assessments/types/FormParts';
import type { InVideoQuestion } from 'bundles/video-quiz/types';

class VideoQuiz {
  public declare readonly questions: InVideoQuestion<QuizQuestionPrompt>[];

  public declare readonly sessionId: string;

  constructor({ sessionId, questions }: { sessionId: string; questions: InVideoQuestion<QuizQuestionPrompt>[] }) {
    this.sessionId = sessionId;
    this.questions = questions;
  }
}

export default VideoQuiz;
